import React, { useState } from 'react';
import { projects } from '../data/mock';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { ExternalLink } from 'lucide-react';

const ProjectsSection = () => {
  const [filter, setFilter] = useState('Todos');
  
  const categories = ['Todos', ...new Set(projects.map(p => p.category))];
  
  const filteredProjects = filter === 'Todos' 
    ? projects 
    : projects.filter(p => p.category === filter);

  return (
    <section id="projects" className="relative py-24 lg:py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-slate-900">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-cyan-950/20 via-slate-900 to-slate-900" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-cyan-500/10 border border-cyan-500/20 text-cyan-400 text-sm font-medium mb-4">
            Amamos o que fazemos
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            Projetos{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-teal-400">
              Recentes
            </span>
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto">
            Conheça alguns dos projetos que desenvolvemos para nossos clientes,
            sempre com foco em qualidade e inovação.
          </p>
        </div>

        {/* Filter Tabs */}
        <div className="flex flex-wrap justify-center gap-2 mb-12">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setFilter(cat)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
                filter === cat
                  ? 'bg-cyan-500 text-slate-900'
                  : 'bg-slate-800/50 text-slate-400 hover:bg-slate-800 hover:text-white'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Projects Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredProjects.map((project, index) => (
            <Card
              key={project.id}
              className="group bg-slate-800/30 border-slate-700/50 overflow-hidden hover:border-cyan-500/30 transition-all duration-500"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/50 to-transparent opacity-60 group-hover:opacity-80 transition-opacity" />
                
                {/* Overlay Content */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300">
                  <div className="w-12 h-12 rounded-full bg-cyan-500/20 backdrop-blur-sm border border-cyan-500/30 flex items-center justify-center">
                    <ExternalLink className="h-5 w-5 text-cyan-400" />
                  </div>
                </div>
                
                {/* Badge */}
                <div className="absolute top-4 left-4">
                  <Badge className="bg-cyan-500/20 text-cyan-400 border-cyan-500/30 backdrop-blur-sm">
                    {project.category}
                  </Badge>
                </div>
              </div>
              
              <CardContent className="p-5">
                <h3 className="text-lg font-semibold text-white mb-1 group-hover:text-cyan-400 transition-colors">
                  {project.title}
                </h3>
                <p className="text-sm text-slate-500">{project.client}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Quote */}
        <div className="mt-20 text-center">
          <div className="max-w-3xl mx-auto bg-slate-800/30 border border-slate-700/50 rounded-2xl p-8 lg:p-12">
            <blockquote className="text-xl sm:text-2xl text-slate-300 italic leading-relaxed mb-4">
              "Acreditamos na colaboração mútua entre fornecedores e clientes. O sucesso de nosso cliente e parceiro é o nosso sucesso."
            </blockquote>
            <p className="text-cyan-400 font-medium">— WCOM Digital</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
